/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  DeleteClientCreditCard: (params: vp.DeleteClientCreditCardRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDeleteClientCreditCard: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldDeleteClientCreditCard, setShouldDeleteClientCreditCard] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DeleteClientCreditCardRequest>({
    PortalUser: '',
    CreditCardToken: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldDeleteClientCreditCard) return () => {};

    const PostDeleteClientCreditCard = async () => {
      setDataFetchingInfo(true, 'Deleting account', 'fullScreen');
      const res = await api.postDeleteClientCreditCard(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteClientCreditCard) void PostDeleteClientCreditCard();
    setShouldDeleteClientCreditCard(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteClientCreditCard]);

  return [
    response,
    (_params: vp.DeleteClientCreditCardRequest) => {
      setParams(_params);
      setShouldDeleteClientCreditCard(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldDeleteClientCreditCard(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDeleteClientCreditCard);